import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';

const PrivateRoute = ({ children, ...rest }) => {
  const { currentUser } = useContext(UserContext);
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={({ location }) => (currentUser ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: '/owners/login',
            state: { from: location },
          }}
        />
      ))}
    />
  );
};

export default PrivateRoute;
